
function Loading () {
  return (
    <p><i>Loading...</i></p>
  )
}

export default Loading;